import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { WFTaskConfig, WFStepConfig, WFSectionConfig } from '../../../workflow/workflow';
import { FormType } from 'src/app/common/enumerations/enumerations';
import { WorkFlowService } from 'src/app/components/workflow/workflow.service';
import { Tooltip } from 'src/app/common/tooltip';

@Component({
  selector: 'scf-v2-settings-signatures',
  templateUrl: './scf-v2-settings-signatures.component.html',
  styleUrls: ['./scf-v2-settings-signatures.component.scss']
})
/**
 * Read-only view of the active SCF signature workflow.
 * US 6920: Editing, reordering and moving signatures was removed from SCF Settings; changes are made as a new
 * version in Global Workflows and only take effect once a different Super Admin approves it.
 */
export class ScfV2SettingsSignaturesComponent implements OnInit {

  @Output() isLoading = new EventEmitter<boolean>();

  sections: any[] = [
    { id: 2, name: 'Work Authorizations', orientation: 'horizontal' },
    { id: 3, name: 'Work Complete', orientation: 'horizontal' },
    { id: 4, name: 'Operational Approval', orientation: 'vertical' },
    { id: 6, name: 'Amendments', orientation: 'horizontal' }
  ];

  workflow?: WFSectionConfig[];

  constructor(
    private _workflow: WorkFlowService
  ) { }

  ngOnInit(): void {
    this.loadWFConfiguration();
  }

  loadWFConfiguration() {
    this.isLoading.emit(true);
    this._workflow.getWFSectionsByForm(FormType.SCF).toPromise().then(data => {
      this.workflow = data;
      this.isLoading.emit(false);
    });
  }

  getSteps(id: number) {
    const section = this.workflow?.find(x => x.number == id);
    return section?.wfStepConfigs;
  }

  getTasks(step: WFStepConfig) {
    return step.wfTaskConfigs?.sort((a, b) => (a.order ?? 0) - (b.order ?? 0)) ?? [];
  }

  getRoleIds(task: WFTaskConfig) {
    return task.wfRoleConfigs?.map(r => r.roleID);
  }

  getRoleCodes(task: WFTaskConfig) {
    return task.wfRoleConfigs?.map(r => r.roleCode).join('/');
  }

  getAction(action: number, task: WFTaskConfig) {
    return task.wfActionConfigs?.some(x => x.action == action);
  }

  getTooltips(task: WFTaskConfig) {
    const tooltips = [] as Tooltip[];
    task.wfActionConfigs?.map(x => {
      const section = this.workflow?.find(w => w.wfStepConfigs?.some(s => s.id == x.wfNextStepConfigID));
      const step = section?.wfStepConfigs.find(s => s.id == x.wfNextStepConfigID);
      if (step) {
        const tooltip: Tooltip = { action: x.action, content: 'GOTO: <b class="blue">' + step?.name + '</b>' };
        tooltips.push(tooltip);
      }
    });
    return tooltips;
  }

  calcWidth(step: WFStepConfig) {
    const tasks = this.getTasks(step);
    if ((tasks?.length ?? 0) > 3) {
      return (80 / (tasks?.length ?? 0)) + '%';
    }
    else {
      return '30%';
    }
  }
}
